// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-main[data-v-5d45898c] {\n  padding: 0;\n  /* overriden by 'app' prop */\n}\n.c-main .c-full[data-v-5d45898c] {\n  min-height: calc(var(--c-viewport-height) - var(--c-top-bar-height));\n}\n.c-main .xc-mobile[data-v-5d45898c] {\n  padding-bottom: var(--c-bottom-bar-height);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
